import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "itemTypeSelect", "productsSelect", "brandsSelect", "tagsSelect", "categoriesSelect", "itemsContainer" ]

  connect() {
    this.toggleFields()
  }

  toggleFields() {
    const select = this.itemTypeSelectTarget.querySelector('select[name="ecommerce_homepage_card[item_type]"]')
    if (!select) return
    const itemType = select.value

    this.productsSelectTarget.style.display = itemType === "product" ? "block" : "none"
    this.brandsSelectTarget.style.display = itemType === "brand" ? "block" : "none"
    this.tagsSelectTarget.style.display = itemType === "tag" ? "block" : "none"
    this.categoriesSelectTarget.style.display = itemType === "category" ? "block" : "none"

    // hide any dynamic items area on type change
    this.itemsContainerTargets.forEach(tc => tc.style.display = "none")
  }

  // triggered on parent selects change (brand/tag/category)
  parentChanged(event) {
    const el = event.currentTarget
    const selectedId = el.value
    const type = el.dataset.type

    // find the nearest itemsContainer (we render one per parent block)
    const itemsContainer = el.closest('[data-homepage-toggle-target]').querySelector('[data-homepage-toggle-target="itemsContainer"]')
    if (!itemsContainer) return

    if (!selectedId) {
      itemsContainer.style.display = "none"
      itemsContainer.querySelector('.dynamic-items-select').innerHTML = ""
      return
    }

    // find form and read the products_for URL provided by Rails (fallback to a sensible namespaced path)
    const form = el.closest('form') || this.element.closest('form') || document.querySelector('form[data-controller="homepage-toggle"]')
    const baseUrl = (form && form.dataset && form.dataset.productsForUrl) ? form.dataset.productsForUrl : '/ecommerce_admin/homepage_cards/products_for.json'
    const url = `${baseUrl}?type=${encodeURIComponent(type)}&id=${encodeURIComponent(selectedId)}`

    fetch(url)
      .then(r => r.json())
      .then(data => {
        const select = itemsContainer.querySelector('.dynamic-items-select')
        select.innerHTML = ""
        data.forEach(opt => {
          const o = document.createElement('option')
          o.value = opt.id
          o.text = opt.text
          select.appendChild(o)
        })
        itemsContainer.style.display = "block"
      })
      .catch(() => {
        itemsContainer.style.display = "none"
      })
  }

  // enforce max 4 selections on any items multi-select
  limitSelection(event) {
    const select = event.currentTarget
    const max = 4
    const selected = Array.from(select.selectedOptions)
    if (selected.length > max) {
      // deselect last chosen
      selected[selected.length - 1].selected = false
      alert(`You can select up to ${max} items.`)
    }
  }
}
